import { navigate } from 'gatsby';
import React, { createRef, useEffect, useState } from 'react';

import UI from '#front-credpago';

import { apiSlim } from '../../services/api';
import useResizer from '../../utils/useResizer';
import { Layout } from '../index';
import Question from './question';
import questions from './questions';
import * as S from './styles';

const ActivationSurvey = ({ personID }) => {
  const [confirmation, setConfirmation] = useState(false);
  const [hasFieldError, setHasFieldError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [answers, setAnswers] = useState({
    atendimento: '',
    agilidade: '',
    indicar: '',
  });

  const txtRef = createRef(null);

  const isMobile = useResizer();
  const numberOfQuestions = questions.length + 1;

  const questionsMap = {
    1: 'atendimento',
    2: 'agilidade',
    3: 'indicar',
    4: 'txt',
  };

  const handleChangeStep = (step) => {
    setHasFieldError(false);
    if (answers[questionsMap[currentQuestion]] === '' && step > currentQuestion) {
      setHasFieldError(true);
      return null;
    }

    setCurrentQuestion(step);
  };

  const handleSubmit = async () => {
    const txt = txtRef.current.value;

    setHasFieldError(false);
    if (txt === '' || txt === null) {
      setHasFieldError(true);
      return null;
    }
    setIsLoading(true);
    setError('');

    try {
      const data = {
        ...answers,
        txt,
        id_pessoa: personID,
      };
      const response = await apiSlim.post('marketing/pesquisa_satisfacao/', data);

      setIsLoading(false);

      if (!response.data) {
        setError('Ocorreu um erro ao enviar sua resposta. Tente novamente.');

        return;
      }

      setConfirmation(true);
    } catch (error) {
      setIsLoading(false);
      setError('Ocorreu um erro ao enviar sua resposta. Tente novamente.');
    }
  };

  useEffect(() => {
    if (!personID) {
      navigate('/');
    }
  }, []);

  return (
    <Layout internal={true} displayImobsParceiras={false}>
      <S.Container>
        <S.Wrapper>
          <UI.Title
            level={1}
            fontWeight={700}
            splitLabel={['Pesquisa de', 'Ativação']}
            style={{ textAlign: 'center', marginBottom: 15 }}
          />

          {!confirmation ? (
            <>
              <UI.Description color="gray" style={{ textAlign: 'center' }}>
                Preencha abaixo a pesquisa de ativação e ajude a melhorar nosso atendimento.
              </UI.Description>
              <S.WrapperQuestion>
                {questions.map((question, index) => {
                  if (currentQuestion === question.id) {
                    return (
                      <Question
                        key={index}
                        id={question.id}
                        name={question.name}
                        options={question.options}
                        title={question.text}
                        value={answers[questionsMap[question.id]]}
                        handleChange={(field, value) =>
                          setAnswers((prevState) => ({
                            ...prevState,
                            [field]: value,
                          }))
                        }
                        hasError={hasFieldError}
                      />
                    );
                  }

                  return '';
                })}

                {currentQuestion === numberOfQuestions && (
                  <>
                    <S.Question>Gostaria de apontar algum elogio, sugestão ou reclamação?</S.Question>
                    <S.WrapperTextArea>
                      <UI.TextAreaLabel
                        // value={answers.txt}
                        // onChange={e => setAnswers(prevState => {
                        //   console.log(e.target)
                        //   return ({
                        //     ...prevState,
                        //     txt: e.target.value
                        //   })
                        // })}
                        ref={txtRef}
                        id="obervation"
                        disabled={isLoading}
                      />
                    </S.WrapperTextArea>

                    {hasFieldError && answers.txt === '' && (
                      <S.Error style={{ marginTop: 20 }}>Informe sua opinião.</S.Error>
                    )}
                  </>
                )}
              </S.WrapperQuestion>

              {!!error && currentQuestion === numberOfQuestions && (
                <S.AlertWrapper>
                  <UI.Alert message={error} type="error" />
                </S.AlertWrapper>
              )}

              <S.WrapperButtons>
                <S.WrapperBtn>
                  {currentQuestion > 1 && (
                    <UI.Button
                      label="Voltar"
                      onClick={() => {
                        handleChangeStep(currentQuestion > 1 ? currentQuestion - 1 : 1);
                      }}
                      type={currentQuestion === 1 ? 'link' : 'default'}
                      blocked
                    />
                  )}
                </S.WrapperBtn>

                {!isMobile && (
                  <UI.Description color="gray" style={{ margin: '0px 30px 0px 30px' }}>
                    {`${currentQuestion} de ${numberOfQuestions}`}
                  </UI.Description>
                )}

                <S.WrapperBtn>
                  <UI.Button
                    type={currentQuestion === numberOfQuestions ? 'success' : 'primary'}
                    label={currentQuestion === numberOfQuestions ? 'Enviar' : 'Avançar'}
                    onClick={() => {
                      if (currentQuestion >= numberOfQuestions) {
                        handleSubmit();
                      } else {
                        handleChangeStep(currentQuestion <= questions.length ? currentQuestion + 1 : questions.length);
                      }
                    }}
                    htmlType="submit"
                    blocked
                    disabled={isLoading}
                    loading={isLoading}
                  />
                </S.WrapperBtn>
              </S.WrapperButtons>
            </>
          ) : (
            <S.WrapperConfirmation>
              <UI.Description color="gray" style={{ textAlign: 'center' }}>
                Muito obrigado por responder nossa Pesquisa de Ativação.
              </UI.Description>

              <S.AlertWrapper style={{ marginTop: 30 }}>
                <UI.Alert message="Vamos analisar sua resposta com muito carinho!" type="success" />
              </S.AlertWrapper>
            </S.WrapperConfirmation>
          )}
        </S.Wrapper>
      </S.Container>
    </Layout>
  );
};

export default ActivationSurvey;
